import { useCallback, useContext, useEffect, useRef, useState } from "react";
import useMultiLanguage from "../../../hook/useMultiLanguage";
import AppContext from "../../../AppContext";
import { LIST_MONTH, SEARCH_OBJECT_MAX_SIZE, TYPE, TYPE_REF, VARIABLE_STRING } from "../../constants/moduleConsts";
import { RESPONSE_STATUS_CODE } from "../../auth/core/_consts";
import { toast } from "react-toastify";
import { getFullYear } from "../../utils/functionUtils";
import { GroupButton } from "../../components/GroupButton";
import { Col, Row } from "react-bootstrap";
import TextValidator from "../../components/input/text-validator";
import TableTimesheetSchedule from "./TableTimesheetSchedule";
import { LIST_TYPE_SCHEDULE } from "../../category/constants/approvalConfigConsts";
import Autocomplete from "../../components/input/autocomplete";
import { autoUpdateTimeSheetSchedule, searchTimeSheetSchedule, updateTimeSheetSchedule } from "../services/timesheetServices";
import { IAttribution, IKHChamCong, ITableTimesheet } from "../models/timesheetModels";
import { getListWorkDay, searchSymbol } from "../../category/services/symbolServices";
import DialogPrintTimekeepingSchedule from "./DialogPrintTimekeepingSchedule";
import { CODE_WEEKEND, LIST_DEFAULT_CODE_TIMEKEEPING_SCHEDULE } from "../constants/timesheetConsts";

const TimesheetScheduleForm = (props: any) => {
    const { timesheetInfo, handleClose, handleCloseAndSearch } = props;
    const { lang } = useMultiLanguage();
    const { setPageLoading } = useContext(AppContext);
    const refsArray = useRef<any[]>([]);

    const [isView, setIsView] = useState<boolean>(true);
    const [isShowSymbol, setIsShowSymbol] = useState<boolean>(false);
    const [initDataTable, setInitDataTable] = useState<any[]>([]);
    const [listAttribution, setListAttribution] = useState<IAttribution[]>([]);
    const [dataKHChamCong, setDataKHChamCong] = useState<IKHChamCong[]>([]);
    const [searchObject, setSearchObject] = useState<any>({
        dayTrucId: timesheetInfo?.dayTrucId,
        dayTrucName: timesheetInfo?.dayTrucName,
        nam: timesheetInfo?.nam,
        thang: timesheetInfo?.thang,
    });
    const [openDialogPrint, setOpenDialogPrint] = useState<any>({
        open: false,
        dataSearchPrint: null
    });

    const getDataKHChamCong = async () => {
        try {
            const { data } = await searchSymbol(SEARCH_OBJECT_MAX_SIZE);
            if (data?.code === RESPONSE_STATUS_CODE.SUCCESS) {
                let listData = data.data.content || [];
                listData = listData.filter((item: IKHChamCong) =>
                    LIST_DEFAULT_CODE_TIMEKEEPING_SCHEDULE.includes(item.defaultCode)
                );
                listData.forEach((item: IKHChamCong) => item.isEdited = true);
                setDataKHChamCong(listData);
                return;
            }
            toast.warning(data?.message);
        } catch (error) {
            toast.error(lang("GENERAL.ERROR"));
        }
    };

    const getListAttribution = useCallback(async (searchData: any = {}) => {
        try {
            const { data } = await getListWorkDay(searchData);
            if (data?.code === RESPONSE_STATUS_CODE.SUCCESS) {
                setListAttribution(data.data.content);
            } else toast.warning(data?.message);
        } catch (error) {
            toast.error(lang("GENERAL.ERROR"));
        }
    }, [lang]);

    useEffect(() => {
        getDataKHChamCong();
        handleSearch(searchObject);
    }, []);

    useEffect(() => {
        getListAttribution();
    }, [getListAttribution]);

    const handleSearch = async (searchObject: any) => {
        try {
            setPageLoading(true);
            setOpenDialogPrint({
                open: false,
                dataSearchPrint: searchObject
            })
            const { data } = await searchTimeSheetSchedule(searchObject);
            if (data?.code === RESPONSE_STATUS_CODE.SUCCESS) {
                setInitDataTable(data?.data?.content || [])
                setIsView(true);
                return;
            }
            toast.warning(data?.message);
        } catch (error) {
            toast.error(lang("GENERAL.ERROR"));
        } finally {
            setPageLoading(false);
        }
    };

    const handleChangeSelect = (name: string, value: any) => {
        switch (name) {
            case VARIABLE_STRING.THANG:
                setSearchObject({
                    ...searchObject,
                    thang: value?.code
                });
                break;
            case VARIABLE_STRING.NAM:
                setSearchObject({
                    ...searchObject,
                    nam: value?.name
                })
        }
    }

    const handleExportExcel = () => {
        if (!initDataTable.length) {
            toast.warning(lang("GENERAL.NO_DATA_TO_EXPORT"));
            return;
        }

        let { donViCongTacCode, donViCongTacText, phongBanId, phongBanText, nam, thang } = timesheetInfo;
        let searchObject = {
            ...SEARCH_OBJECT_MAX_SIZE,
            nam,
            thang,
            phongBanId,
            phongBanText,
            orgCode: donViCongTacCode,
            orgText: donViCongTacText,
        };
        // exportToFile({
        //     exportAPI: () => exportTimeSheetOvertime(searchObject),
        //     fileName: `${EXPORT_FILE_NAME.BANG_CHAM_CONG_THEM_GIO}${thang ? " tháng " + thang
        //         : ""}${nam ? " năm " + nam : ""}`,
        //     setPageLoading
        // });
    }

    const handleConvertTableRef = (data: any[], dataTable: ITableTimesheet[] = []): any => {
        let dataArray: any[] = dataTable.map(item => ({ ...item }));

        for (let itemRef of data || []) {
            let indexItem = dataArray.findIndex((itemBN: ITableTimesheet) => itemBN?.id === itemRef?.[VARIABLE_STRING.EMPLOYEE]?.id);

            if (indexItem < 0) return;

            for (let [key, value] of Object.entries(itemRef)) {
                if (key === VARIABLE_STRING.EMPLOYEE) continue;

                let listValue = (value as any).getValue();
                let itemValue = checkIsEditedItem(dataArray[indexItem][key], listValue?.[0])

                dataArray[indexItem][key] = itemValue
            }
        }

        return dataArray;
    }

    const checkIsEditedItem = (itemBefore: IKHChamCong | null | undefined, itemAfter: IKHChamCong | null | undefined) => {
        if (itemBefore && !itemAfter) {
            return {
                id: itemBefore?.defaultCode === CODE_WEEKEND ? itemBefore?.id : null,
                isEdited: itemBefore?.defaultCode !== CODE_WEEKEND
            }
        };

        if ((!itemBefore && !itemAfter) || (itemBefore && itemAfter && itemBefore?.id === itemAfter?.id)) {
            return {
                id: itemBefore?.id,
                isEdited: false
            }
        };

        return {
            id: itemAfter?.id,
            isEdited: true
        }
    }

    const handleCheckEdited = (dataTable: ITableTimesheet[]) => {
        return dataTable.filter((item: ITableTimesheet) => {
            let isCheck = Object.entries(item).some(([key, value]) => value?.isEdited);
            if (!isCheck) return isCheck;

            for (let [key, value] of Object.entries(item)) {
                if (typeof value === TYPE.OBJECT && !value?.id && !value?.isEdited) (item as any)[key] = null
            }
            return isCheck;
        }) || []
    }

    const handleSubmit = useCallback(async () => {
        try {
            let dataTable: ITableTimesheet[] = handleConvertTableRef(refsArray.current, [...initDataTable]);
            let { data } = await updateTimeSheetSchedule(handleCheckEdited(dataTable || []))
            if (data?.code === RESPONSE_STATUS_CODE.SUCCESS) {
                toast.success(lang("TOAST.EDIT.SUCCESS"));
                handleSearch(searchObject);
                return;
            }
            toast.warn(data?.message);
        } catch (error) {
            console.error("ERROR", error);
            toast.error(lang("GENERAL.ERROR"));
        } finally {
            setPageLoading(false);
        }
    }, [searchObject, initDataTable]);

    const setRefsArray = useCallback((index: any, key: any, typeRef: string = TYPE_REF.INPUT_REF, id: string) => (element: any) => {
        let newElement = element ? element : {}
        newElement.typeRef = typeRef;
        newElement.id = id;
        refsArray.current[index] = refsArray.current[index] || {};
        refsArray.current[index][key] = newElement;
    }, []);

    const handleIsView = useCallback((isViews: boolean) => {
        setPageLoading(true)
        setTimeout(() => {
            setIsView(isViews)
             setPageLoading(false)
        }, 10)
    }, [])

    const updateAutoTimeSheetSchedule = useCallback(async () => {
        try {
            setPageLoading(true);
            const { data } = await autoUpdateTimeSheetSchedule(searchObject);
            if (data?.code === RESPONSE_STATUS_CODE.SUCCESS) {
                toast.success(lang("TOAST.EDIT.SUCCESS"));
                handleSearch(searchObject);
            } else toast.warning(data?.message);
        } catch (error) {
            toast.error(lang("GENERAL.ERROR"));
        } finally {
            setPageLoading(false);
        }
    }, [searchObject]);

    return (
        <div>
            <div className="header-form-action">
                <GroupButton type="btn-back" handleClose={handleClose} />
                <div className="flex gap-4">
                    <GroupButton handleEvent={updateAutoTimeSheetSchedule} className="spaces mr-4">{lang("BTN.UPDATE")}</GroupButton>
                </div>
            </div>
            <div className="form-content-scroll">
                <Row className="g-3 pt-3 mb-3">
                    <Col xs={12} sm={6} md={6} lg={3}>
                        <TextValidator
                            name="name"
                            lable={lang("SCHEDULE_CONFIG.NAME")}
                            type="text"
                            value={timesheetInfo?.dayTrucName || ""}
                            readOnly
                        />
                    </Col>
                    <Col xs={12} sm={6} md={3} lg={2}>
                        <TextValidator
                            name={VARIABLE_STRING.NAM}
                            lable={lang("GENERAL.YEAR")}
                            type="text"
                            value={searchObject?.nam || ""}
                            readOnly
                        />
                    </Col>
                    <Col xs={12} sm={6} md={3} lg={2}>
                        <TextValidator
                            name={VARIABLE_STRING.THANG}
                            lable={lang("GENERAL.MONTH")}
                            type="text"
                            value={Number(searchObject?.thang) || ""}
                            readOnly
                        />
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} className={!isShowSymbol ? "show-full" : ""}>
                        <div className="relative pt-2 mb-3">
                            <p className='fw-bold text-uppercase fs-1 text-center m-0'>bảng chấm công dây trực</p>
                            <p className='fw-bold fs-4 text-center m-0'>{`Tháng ${timesheetInfo.thang ?? "....."} năm ${timesheetInfo.nam ?? "....."}`}</p>
                            <div className="position-absolute bottom-0 end-0 d-flex spaces gap-2">
                                {isView ?
                                    <GroupButton type="btn-edit" handleSaveEdit={() => handleIsView(false)} />
                                    :
                                    <>
                                        <GroupButton
                                            type="btn-cancel"
                                            handleCloseUpdateDialog={() => handleIsView(true)}
                                        />
                                        <GroupButton type="btn-save" handleSubmit={handleSubmit} />
                                    </>
                                }
                                <GroupButton handleEvent={() => setOpenDialogPrint((prev: any) => {
                                    return {
                                        ...prev,
                                        open: true
                                    }
                                })}>
                                    {lang("BTN.PRINT")}
                                </GroupButton>
                                {/* <GroupButton outline handleEvent={() => handleExportTimekeeping()}>
                                    <KTSVG path="/media/icons/export-excel.svg" />{" "}
                                    {lang("BTN.EXPORT")}
                                </GroupButton> */}
                            </div>
                        </div>
                        <TableTimesheetSchedule
                            data={[...initDataTable]}
                            dateSearch={timesheetInfo}
                            dataKHChamCong={dataKHChamCong}
                            isView={isView}
                            refsArray={refsArray}
                            setRefsArray={setRefsArray}
                            listAttribution={listAttribution}
                        />
                    </Col>
                </Row>
            </div>
            {openDialogPrint.open &&
                <DialogPrintTimekeepingSchedule
                    open={openDialogPrint}
                    dateSearch={{
                        ...openDialogPrint.dataSearchPrint,
                        ...timesheetInfo
                    }}
                    listAttribution={listAttribution}
                    handleClose={() => setOpenDialogPrint({
                        open: false,
                        dataSearchPrint: null
                    })}
                />
            }
        </div>
    )
};

export default TimesheetScheduleForm;